module.exports = __webpack_public_path__ + "img/google-street-view-icon-5.ac3af8ab.png";